import { useEffect, useRef } from 'react';

import { getPlanReviewSignal } from '@personal-trainer-app/shared/src/utils/questionnaire/questionnaire-form';

import {
  useAuthStore,
  useJobProgressStore,
  useNotificationStore,
} from '@/stores';

/**
 * Keeps `plan_review` on the session user current.
 *
 * The review of a user's questionnaire answers is carried on the session
 * user, which is otherwise read at sign-in. When something says the review
 * has moved — a `plan_review_*` notification arrives, or a generation job ends
 * held — the user is read again, so the dashboard's card follows an approval
 * or a decline without a reload.
 *
 * Headless; call once inside the authenticated tree.
 */
export function usePlanReviewSync(): void {
  const notifications = useNotificationStore((state) => state.notifications);
  const jobs = useJobProgressStore((state) => state.jobs);
  const fetchUser = useAuthStore((state) => state.fetchUser);

  const signal = getPlanReviewSignal(notifications, jobs);
  // What was already there when the watch began is not news.
  const lastSignalRef = useRef(signal);

  useEffect(() => {
    if (signal === lastSignalRef.current) return;
    lastSignalRef.current = signal;
    if (signal) void fetchUser();
  }, [signal, fetchUser]);
}

export default usePlanReviewSync;
